export const central_api_domain = process.env.VUE_APP_API_URL;
export const b2b_portal_api_url = process.env.VUE_APP_PORTAL_API_URL;
